(function (angular) {
	angular.module('bizPartEngage').service('BizCampaignService', campaignService);

	campaignService.$inject = ["$http"];

    function campaignService($http) {
    	var controllerPath = siteRootPath + "api/CampaignUser/";

    	return {
    		GetCampaign: GetCampaign,
    		GetCampaignPage: GetCampaignPage
    	};

    	function GetCampaign(urlRewrite) {
    		return $http.get(controllerPath + "GetCampaign", {
    			params: {
    				urlRewrite: urlRewrite
    			}
    		});
    	}

    	function GetCampaignPage(pageId) {
    		return $http.get(controllerPath + "GetCampaignPage", {
    			params: {
    				id: pageId
    			}
    		});
    	}
    }
})(window.angular);
